var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('Input',{attrs:{"type":"password","placeholder":_vm.definition.instructions},model:{value:(_vm.buffer),callback:function ($$v) {_vm.buffer=$$v},expression:"buffer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }